export default __webpack_public_path__ + "static/media/018-dumbbell.7991ef20.svg";